import { useEffect, useRef } from "react";
import lottie from "lottie-web";
import styles from "./Lottie.module.css";

const LottieLayout = ({
  layout,
}) => {
  const svgContainer = useRef();
  const loaded = useRef(false);

  useEffect(() => {
    if (!svgContainer.current || loaded.current) return;

    lottie.loadAnimation({
      container: svgContainer.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: layout.lottie_json,
    });

    loaded.current = true;
  }, [svgContainer.current]);

  return (
    <div className={styles.lottieWrapper}>
      <div ref={svgContainer} className={styles.lottieContainer}></div>
    </div>
  );
};

export default LottieLayout;
